import { atom, useRecoilState, useRecoilValue } from "recoil";
type InstantMessage =
  | { title: string, message?: string }
  | { title?: string, message: string }
  | { title: string; message: string };
export const instantMessageState = atom<InstantMessage>({
  key: "instantMessageState",
  default: undefined,
});

export function useInstantMessage() {
  const instantMessage = useRecoilValue(instantMessageState);
  return instantMessage;
}

export function useInstantMessageSetter() {
  const [, setInstantMessage] = useRecoilState(instantMessageState);
  return setInstantMessage;
}
